var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 8H22.5C20.5109 8 18.6032 8.79018 17.1967 10.1967C15.7902 11.6032 15 13.5109 15 15.5V75.5C15 77.4891 15.7902 79.3968 17.1967 80.8033C18.6032 82.2098 20.5109 83 22.5 83H67.5C69.4891 83 71.3968 82.2098 72.8033 80.8033C74.2098 79.3968 75 77.4891 75 75.5V30.5M52.5 8L75 30.5M52.5 8V30.5H75M60 49.25H30M60 64.25H30M37.5 34.25H30",
    stroke: "#18AB7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/FileText.5f6d0c75cc571bcfb2b75b523ef4082b.svg";
export { ForwardRef as ReactComponent };